







































import Vue from 'vue'
import * as R from 'ramda'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/patient-with-summary-reports/keys'
import { buildTimelineChartOptions } from './timeline-chart-options/timeline-chart-options'
import moment from 'moment-timezone'
import { CHART_DATE_FORMAT } from '@/components/patient-stats/constants'
import { FlatPatientWithSummaryReports } from '@/store/modules/patient-with-summary-reports/getters'
import SeriesScatter = echarts.EChartOption.SeriesScatter
import SeriesCustom = echarts.EChartOption.SeriesCustom
import SeriesBar = echarts.EChartOption.SeriesBar

export default Vue.extend({
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isInitialized: false,
      openDialog: false,
      noteForDialog: null,
      timelineChartWrapperWidth: 0 as number,
      updateTimer: null as null | number,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patientWithSummaryReports, [GetterNames.patientWithSummaryReports]),
    patientWithSummaryReports(): FlatPatientWithSummaryReports | undefined {
      return this[GetterNames.patientWithSummaryReports].find(patientWithSR => patientWithSR.id === this.patientId)
    },
    hasData() {
      const incidentsLength = R.pathOr(0, ['incidents', 'length'], this.patientWithSummaryReports)
      const notesLength = R.pathOr(0, ['patientNotes', 'length'], this.patientWithSummaryReports)
      return 0 < incidentsLength + notesLength
    },
    chartOptions(): echarts.EChartOption<SeriesBar | SeriesCustom | SeriesScatter> {
      if (this.timelineChartWrapperWidth === 0) {
        return null
      }
      return buildTimelineChartOptions({
        summaryReports: this.patientWithSummaryReports,
        colors: this.$vuetify.theme.themes.light,
        chartWidth: this.timelineChartWrapperWidth,
      })
    },
  },
  watch: {
    async startTimestamp(n, o) {
      await this.fetchPatientWithSummaryReport()
    },
    async endTimestamp(n, o) {
      await this.fetchPatientWithSummaryReport()
    },
  },
  async mounted() {
    await this.fetchPatientWithSummaryReport()
    window.addEventListener('resize', this.updateChartWrapperWidth)
    this.isInitialized = true
  },
  beforeDestroy(): void {
    window.removeEventListener('resize', this.updateChartWrapperWidth)
  },
  methods: {
    ...mapActions(ModuleNames.patientWithSummaryReports, [ActionNames.getPatientWithSummaryReportsById]),
    async fetchPatientWithSummaryReport() {
      await this[ActionNames.getPatientWithSummaryReportsById]({
        patientId: this.patientId,
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
      })
      this.updateChartWrapperWidth()
    },
    onClickChart(params) {
      if (params.seriesName === 'note-squares') {
        this.openDialog = true
        this.noteForDialog = params.value[2]
      }
    },
    getDateLabelForDialog(timestamp) {
      return moment(timestamp).format(CHART_DATE_FORMAT.DETAIL)
    },
    updateChartWrapperWidth() {
      window.clearTimeout(this.timer)
      this.timer = window.setTimeout(() => {
        const chartWrapper: Element = this.$refs.timelineChartWrapper
        if (chartWrapper) {
          this.timelineChartWrapperWidth = chartWrapper.getBoundingClientRect().width
        }
      }, 200)
    },
  },
})
